import {distinctUntilChanged} from 'rxjs/operators';

export function distinctUntilChangedStringify<T>() {
    return distinctUntilChanged<T>((a, b) => JSON.stringify(a) === JSON.stringify(b));
}
